import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { authReducer } from "@/src/redux/slices/authSlice";
import { baseDataReducer } from "@/src/redux/slices/baseDataSlice";
import { persistStorage } from "@/src/redux/persistStorage";

const authPersistConfig = {
  key: "auth",
  storage: persistStorage,
  blacklist: ["error", "loading"],
};

const baseDataPersistConfig = {
  key: "baseData",
  storage: persistStorage,
  blacklist: ["error", "loading"],
};

export const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  baseData: persistReducer(baseDataPersistConfig, baseDataReducer),
});

export type RootState = ReturnType<typeof rootReducer>;
